import { join } from "path";
import winston from "winston";
import formatter from "../formatters/basic";
import "winston-daily-rotate-file";

export const create = (
	appDataLogsPath: string,
	loggingMaxFiles: string | number = 3,
	loggingMaxSize: string = "5m",
	sanitizingRegExes: RegExp[] = []
) =>
	new winston.transports.DailyRotateFile({
		format: formatter(sanitizingRegExes),
		datePattern: "YYYY-MM-DD",
		maxSize: loggingMaxSize,
		maxFiles: loggingMaxFiles,
		filename: join(appDataLogsPath, "FEA-%DATE%.log"),
		createSymlink: true,
		symlinkName: "current-FEA.log",
	});
